import { useState } from 'react';
import { css } from '@eti/styles';
import { rowItemSize, resetButtonStyles } from '../../utils/styles';
import { getSeatIcon } from '../../utils/seat';
import SeatTooltip from './SeatTooltip';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const buttonStyles = css`
  cursor: pointer;
  ${resetButtonStyles};
  ${rowItemSize};
  outline: 0;
  position: relative;

  svg {
    height: 100%;
    width: 100%;
  }
`;
const initialsStyles = css`
  color: #fff;
  font-size: 0.875rem;
  font-weight: 600;
  left: 0;
  position: absolute;
  right: 0;
  text-align: center;
  top: 0.25rem;
`;
const BookableSeat = _ref => {
  let {
    isActive,
    carrier,
    column,
    row,
    onChange = () => {},
    price,
    seat,
    isSelected,
    mainCharacteristic,
    markup,
    selectedSeatInitials
  } = _ref;
  const [hasFocus, setHasFocus] = useState(false);
  const handleFocus = () => {
    setHasFocus(true);
  };
  const handleBlur = () => {
    setHasFocus(false);
  };
  const tooltipId = `seat_${seat}`;
  const SeatIcon = isActive ? getSeatIcon('active') : getSeatIcon(mainCharacteristic, isSelected);
  return /*#__PURE__*/_jsxs("button", {
    "aria-describedby": tooltipId,
    className: buttonStyles,
    "data-event": hasFocus && 'focus' || '',
    "data-event-off": hasFocus && 'focusout' || '',
    "data-for": tooltipId,
    "data-testid": `bookableSeat-${row}-${seat}`,
    "data-tip": true,
    onBlur: handleBlur,
    onClick: onChange({
      price,
      carrier,
      column,
      row,
      seat,
      markup
    }),
    onFocus: handleFocus,
    onMouseOut: handleBlur,
    onMouseOver: handleFocus,
    type: "button",
    children: [isSelected && /*#__PURE__*/_jsx("span", {
      className: initialsStyles,
      children: selectedSeatInitials
    }), /*#__PURE__*/_jsx(SeatIcon, {}), /*#__PURE__*/_jsx(SeatTooltip, {
      id: tooltipId,
      price: price,
      seat: seat
    })]
  });
};
export default BookableSeat;
//# sourceMappingURL=BookableSeat.js.map